module.exports = __webpack_public_path__ + "static/media/blue-gold-leaves.46f2e84a.jpg";